import React from "react";
import "./banner.scss";
import RevealAnimation from "../RevealAnimation";

function PodCastBanner({
  title = "",
  subTitle = "",
  description = "",
  btnLink = "",
  heading = "",
  description_2 = "",
  LineColor = "",
  image = "",
}) {
  return (
    <div className="podcast-about-modern">
      <div className="body-container">
        <div className="about-grid">
          {/* Left: Text */}
          <div className="about-text-col">
            {heading && <p className="about-eyebrow">{heading}</p>}
            <RevealAnimation component={"h2"} className="about-heading">
              {title}
              {LineColor && (
                <span className="about-heading-accent"> {LineColor}</span>
              )}
            </RevealAnimation>
            {description && (
              <RevealAnimation
                component={"p"}
                animation="fade"
                className="about-desc"
              >
                {description}
              </RevealAnimation>
            )}
            {description_2 && (
              <RevealAnimation
                component={"p"}
                animation="fade"
                className="about-desc about-desc--secondary"
              >
                {description_2}
              </RevealAnimation>
            )}
          </div>

          {/* Right: Feature cards */}
          <div className="about-visual-col">
            <div className="about-feature-card">
              <div className="feature-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
                  <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                  <line x1="12" y1="19" x2="12" y2="23" />
                  <line x1="8" y1="23" x2="16" y2="23" />
                </svg>
              </div>
              <div>
                <p className="feature-label">Deep Conversations</p>
                <p className="feature-desc">
                  Tech, business and life intersect in every episode
                </p>
              </div>
            </div>

            <div className="about-feature-card">
              <div className="feature-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
              </div>
              <div>
                <p className="feature-label">New Episodes Weekly</p>
                <p className="feature-desc">
                  AI, Cloud, and the technology shaping tomorrow
                </p>
              </div>
            </div>

            <div className="about-feature-card">
              <div className="feature-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32" />
                </svg>
              </div>
              <div>
                <p className="feature-label">On All Platforms</p>
                <p className="feature-desc">
                  Available on Spotify, YouTube, and more
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom wave transition to white episodes section */}
      <svg
        className="about-wave-svg"
        viewBox="0 0 1440 60"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <path d="M0,30 C480,60 960,0 1440,30 L1440,60 L0,60 Z" fill="#ffffff" />
      </svg>
    </div>
  );
}

export default PodCastBanner;
